/**
 * Formatage partagé (sprint « traçabilité apprenants » — 01/10/2026).
 */

/** Durée lisible : « 1 h 12 min », « 12 min », « 45 s ». */
export const formatDuration = (seconds?: number | null): string => {
  const total = Math.max(0, Math.round(Number(seconds) || 0));
  if (total < 60) return `${total} s`;
  const minutes = Math.floor(total / 60);
  if (minutes < 60) return `${minutes} min`;
  const hours = Math.floor(minutes / 60);
  const remaining = minutes % 60;
  return remaining > 0 ? `${hours} h ${remaining} min` : `${hours} h`;
};

/** Date + heure lisibles : « 01/10/2026 19:42 ». */
export const formatDateTime = (value?: string | Date | null): string => {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

/** Date seule : « 01/10/2026 ». */
export const formatDate = (value?: string | Date | null): string => {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleDateString('fr-FR');
};

/** Libellé de rôle en français. */
export const formatRole = (role?: string | null): string => {
  switch (role) {
    case 'admin': return 'Administrateur';
    case 'professor': return 'Formateur';
    case 'student': return 'Apprenant';
    default: return role || '—';
  }
};

/** Date au format attendu par les filtres API (yyyy-mm-dd). */
export const toApiDate = (value?: string | null): string | undefined => {
  if (!value) return undefined;
  return value;
};
